import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {JunctionBoxSections, KeyValuePair} from '@/globals';
import {AdminDataFieldService} from '@/views/shared/services';
import {Component} from 'vue-property-decorator';
import {Container, Draggable, DropResult} from 'vue-smooth-dnd';

@Component({
    components: {
        Container,
        Draggable,
    },
})
export default class JunctionBoxFieldsDbComponent extends VueWrapper {
    public junctionBoxSections: Array<KeyValuePair> = [
        {
            key: JunctionBoxSections.ParentAreaInformation,
            value: this.$t('FieldsDbPage.JunctionBoxTab.Sections.ParentAreaInformation').toString(),
            active: false,
        },
        {
            key: JunctionBoxSections.GeneralInformation,
            value: this.$t('FieldsDbPage.JunctionBoxTab.Sections.GeneralInformation').toString(),
            active: true,
        },
        {
            key: JunctionBoxSections.JunctionBoxClassification,
            value: this.$t('FieldsDbPage.JunctionBoxTab.Sections.JunctionBoxClassification').toString(),
            active: false,
        },
        {
            key: JunctionBoxSections.WiringCableEntry,
            value: this.$t('FieldsDbPage.JunctionBoxTab.Sections.WiringCableEntry').toString(),
            active: false,
        },
    ];

    public adminDataFieldsSrv: AdminDataFieldService = new AdminDataFieldService();

    public get getFieldOptions() {
        return this.adminDataFieldsSrv.selectedField ? this.adminDataFieldsSrv.selectedFieldOptions[this.adminDataFieldsSrv.selectedField.id!] : [];
    }

    public get getDependentOptions() {
        return this.adminDataFieldsSrv.selectedFieldOptions[this.adminDataFieldsSrv.selectedField!.id!].filter(
            x => x.dependentOnFieldOptionId === this.adminDataFieldsSrv.dependentFieldOption
        );
    }

    public getJunctionBoxFields(sectionName: string) {
        console.log(
            'Fetching junction box fields for section:',
            sectionName,
            this.adminDataFieldsSrv.junctionBoxFields.filter(f => f.section === sectionName && ['select', 'multi-select'].includes(f.type!))
        );
        return this.adminDataFieldsSrv.junctionBoxFields.filter(f => f.section === sectionName && ['select', 'multi-select'].includes(f.type!));
    }

    public getChildPayload(index: number) {
        return this.getFieldOptions[index];
    }

    public getChildPayloadDependent(index: number) {
        return this.getDependentOptions[index];
    }

    sortingLoader: boolean = false;

    onDrop(payload: DropResult) {
        this.sortingLoader = true;
        this.adminDataFieldsSrv.sortOnDrop(payload).finally(() => {
            this.sortingLoader = false;
        });
    }

    onDropDependent(payload: DropResult) {
        this.sortingLoader = true;
        this.adminDataFieldsSrv.sortOnDrop(payload).finally(() => {
            this.sortingLoader = false;
        });
    }
}
